<template>
  <div class="forceTransfer">
    <el-dialog
      title="强制划转"
      :visible.sync="isShow"
      width="30%"
      :before-close="handleClose"
    >
      <el-form :model="form" ref="form" :rules="rules">
        <el-form-item label="用户id" prop="userId">
          <el-input v-model="form.userId" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="钱包" prop="fromWallet">
          <el-select v-model="form.fromWallet" placeholder="请选择钱包类型">
            <el-option
              v-for="item in wallet"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="转至"></el-form-item>
        <el-form-item label="钱包" prop="toWallet">
          <el-select v-model="form.toWallet" placeholder="请选择钱包类型">
            <el-option
              v-for="item in wallet"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="币种" prop="coinType">
          <el-select v-model="form.coinType" placeholder="请选择钱包类型">
            <el-option
              v-for="item in coin"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="划转数量" prop="amount">
          <el-input v-model="form.amount" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from "../api";
export default {
  name: "ForceTransfer",
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formLabelWidth: "80",
      // isShow: true,
      wallet: [
        {
          label: "现货钱包",
          value: "WALLET",
        },
        {
          label: "杠杆账户",
          value: "MARGIN",
        },
        {
          label: "法币账户",
          value: "OTC",
        },
        {
          label: "合约账户",
          value: "CONTRACT",
        },
      ],
      coin: [
        {
          label: "USDT",
          value: "USDT",
        },
        {
          label: "BKK",
          value: "BKK",
        },
        {
          label: "BTC",
          value: "BTC",
        },
      ],
      form: {
        userId: "",
        fromWallet: "",
        toWallet: "",
        coinType: "USDT",
        amount: "",
      },
      rules: {
        userId: [{ required: true, message: "请输入用户id", trigger: "blur" }],
        fromWallet: [
          {
            required: true,
            message: "请选择要划转的钱包类型",
            trigger: "change",
          },
        ],
        toWallet: [
          {
            required: true,
            message: "请选择要划转的钱包类型",
            trigger: "change",
          },
        ],
        coinType: [
          { required: true, message: "请选择交易币种", trigger: "change" },
        ],
        amount: [
          { required: true, message: "请输入划转数量", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    handleClose() {
      // this.isShow = false
      this.$emit("handleClose");
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          api.transfer(this.form).then(res => {
            if (res.code === 0) {
              this.$message({
                message: '划转成功',
                type: 'success'
              })
            } else {
              this.$message({
                message: `划转失败 ${res.msg}`,
                type: 'error'
              })
            }
          })
          this.isShow = false
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less">
.forceTransfer {
  .el-form-item__label {
    width: 80px;
  }
  .el-input {
    width: 200px;
  }
}
</style>